import gql from "graphql-tag";

export const GetReferralCount = gql`
  query GetLeadsByPartner (
      $PartnerId: ID! 
      $Limit: Int 
      $NextToken: String 
      $Search: String 
      $ClientWithAlerts: Boolean
      $OptOutClientApproval: Boolean
      $LeadStatus: String
    ) {
    GetLeadsByPartner (
      PartnerId: $PartnerId 
      Limit: $Limit
      NextToken: $NextToken 
      Search: $Search
      Filters: { ClientWithAlerts: $ClientWithAlerts, OptOutClientApproval: $OptOutClientApproval LeadStatus: $LeadStatus }
      ) {
        TotalRecords
    }
  }
`;